import './buscar.css'
import imgLupa from './lupa.svg'
// import imgFiltros from './filtros.svg'
// import { Popover } from '@mui/material'
// import { FilterList } from './filterList/FilterList'

export const Buscar = ({ filters, setFilters }) => {

  const handleChange = ({ target }) => {
    // console.log(target.value)

    setFilters({
      ...filters,
      [target.name]: target.value
    })

  }

  return (
    <div className='p-buscar'>
      <img className='p-buscar-lupa' src={imgLupa} alt="buscar" htmlFor="buscador" />

      <input
        type="text"
        placeholder={'Buscar en presupuestos de gastos'}
        id='buscador'
        name='text'
        onChange={handleChange}
      />

      {/* <DropdownFilters
        filters={filters}
        setFilters={setFilters}
      /> */}

    </div>
  )
}

// const DropdownFilters = ({ filters, setFilters }) => {

//   const [anchorEl, setAnchorEl] = useState(null);

//   const handleClick = (event) => {
//     setAnchorEl(event.currentTarget);
//   };

//   const handleClose = () => {
//     setAnchorEl(null);
//   };

//   const open = Boolean(anchorEl);
//   const id = open ? 'simple-popover' : undefined;

//   return (
//     <div>
//       <img aria-describedby={id} variant="contained" className='p-buscar-filtros' src={imgFiltros} alt="filtros" onClick={handleClick} />
//       <Popover
//         className='p-popover-buscar-filtros'
//         id={id}
//         open={open}
//         anchorEl={anchorEl}
//         onClose={handleClose}
//         anchorOrigin={{
//           vertical: 'bottom',
//           horizontal: 'right',
//         }}
//         transformOrigin={{
//           vertical: 'top',
//           horizontal: 'right',
//         }}
//       >

//         <FilterList
//           filters={filters}
//           setFilters={setFilters}
//         />

//       </Popover>
//     </div>
//   )

// }
